import { ReactNode, useEffect, useState } from "react";

type DelayedFallbackProps = {
  readonly children: ReactNode;
  readonly delay?: number;
};

function DelayedFallback({ children, delay = 200 }: DelayedFallbackProps): JSX.Element | null {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const id = window.setTimeout(() => setVisible(true), delay);
    return () => window.clearTimeout(id);
  }, [delay]);

  return visible ? <>{children}</> : null;
}

export default DelayedFallback;
